import { AssistChip, Skeleton, Stack, Text } from '@sixui/ui';

import { Table } from '~/components/molecules/Table';

export const OrganizationInvitationListItemSkeleton: React.FC = () => (
  <Table.Row>
    <Table.Body>
      <Skeleton length={{ min: 8, max: 32 }} />
    </Table.Body>
    <Table.Body>
      <Skeleton length={{ min: 8, max: 16 }}>
        <AssistChip />
      </Skeleton>
    </Table.Body>
    <Stack as={Table.Body} gap={1}>
      <Skeleton length={{ min: 8, max: 16 }} />
      <Text
        as={Skeleton}
        variant="body"
        size="sm"
        length={{ min: 8, max: 16 }}
      />
    </Stack>
    <Stack as={Table.Body} justify="end">
      <Skeleton length={8} />
    </Stack>
  </Table.Row>
);
